import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as intelligentbigdataActions } from "../../../redux/modules/intelligentbigdata";
import IntelligentSearchBox from "./components/IntelligentSearchBox/index_v2";
import IntelligentHomeHead from "./components/IntelligentHomeHead";
import IntelligentDataHead from "./components/IntelligentDataHead";
import IntelligentDataColumn from "./components/IntelligentDataColumn";
import IntelligentDataFilter from "./components/IntelligentDataFilter";
import IntelligentAllMajorModal from "./components/IntelligentAllMajorModal";
import IntelligentMajorModal from "./components/IntelligentMajorModal";
import IntelligentInlineMajorModal from "./components/IntelligentInlineMajorModal";
import IntelligentSchoolDetail from "./components/IntelligentSchoolDetail";
import IntelligentAdvanceModal from "./components/IntelligentAdvanceModal";
import IntelligentAdvanceMajorModal from "./components/IntelligentAdvanceMajorModal";
import ListErrorPrompt from "../../../components/ListErrorPrompt";
import Loading from "../../../components/Loading";
import ReturnTop from "../../../components/ReturnTop";
import InfoModal from "../../../components/InfoModal";
import { jumpUrl } from "../../../utils/tool";
import { post, get } from "../../../utils/request";
import "./style.css";
var finished = true;
// var doWork = false;
class IntelligentBigData extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      data: null,
      dataList: [],
      filterData: null,
      allMajorData: null,
      majorData: null,
      advanceMajorData: null,
      advanceYear: null,
      topVisible: false,
      errorType: "",
      msg: "",
      // params: {
      //   pageNum: 1,
      //   pageSize: 20,
      // },
    };
    this.removeListener = false;
    // window.addEventListener("popstate", (state) => {
    //   doWork = true;
    //   if (doWork === true) {
    //     //this.orderCloseModal(doWork);
    //     history.pushState(null, null, document.URL);
    //     console.log("it is work");
    //   }
    // });
  }
  componentWillMount() {
    this.requestShareConfig();
  }
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    this.requestIsBuy();
    //this.requestUserInfo();
    this.requestSchoolMajorList();
    this.requestSchoolFilter();
    this.handleAddScroll();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    history.pushState(null, null, document.URL);
    document.title = "浙考之家-每日高升-智能大数据";
    if (window.history && window.history.pushState) {
      window.addEventListener("popstate", this.orderCloseModal, false);
    }
  }
  componentDidUpdate() {
    setTimeout(() => {
      if (
        this.props.schoolFilter.pageNum.pageNum >= this.state.data.data.pages &&
        !this.removeListener
      ) {
        document.removeEventListener("scroll", this.handleScroll);
        this.removeListener = true;
      }
    }, 500);
  }

  componentWillUnmount() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    window.removeEventListener("popstate", (state) => {
      this.back();
    });
    if (!this.removeListener) {
      document.removeEventListener("scroll", this.handleScroll);
    }
    const { dispatch } = this.props;
    dispatch(intelligentbigdataActions.setMajorVisible(false));
    dispatch(intelligentbigdataActions.setAllMajorVisible(false));
    dispatch(intelligentbigdataActions.setSchoolDetailVisible(false));
    dispatch(intelligentbigdataActions.setAdvanceMajorModalVisible(false));
    dispatch(intelligentbigdataActions.setAdvanceModalVisible(false));
    dispatch(intelligentbigdataActions.setInlineMajorVisible(false));
  }
  render() {
    const { schoolFilter, uiState } = this.props;

    return (
      <div ref={this.myRef}>
        <IntelligentAdvanceMajorModal
          visible={uiState.advanceMajorModalVisible}
          handleVisibleAdvanceMajorModal={this.handleVisibleAdvanceMajorModal}
          advanceMajorData={this.state.advanceMajorData}
          advanceYear={this.state.advanceYear}
        ></IntelligentAdvanceMajorModal>
        <IntelligentAdvanceModal
          visible={uiState.advanceModalVisible}
          handleVisibleAdvanceModal={this.handleVisibleAdvanceModal}
          handleVisibleAdvanceMajorModal={this.handleVisibleAdvanceMajorModal}
        ></IntelligentAdvanceModal>
        <IntelligentSchoolDetail
          aHashId={uiState.aHashId}
          handleVisibleSchoolDetail={this.handleVisibleSchoolDetail}
          visible={uiState.schoolDetailVisible}
        ></IntelligentSchoolDetail>
        <IntelligentInlineMajorModal
          handleVisibleMajor={this.handleInlineVisibleMajor}
          visible={uiState.inlineMajorVisible}
          majorData={this.state.majorData}
        ></IntelligentInlineMajorModal>
        <IntelligentMajorModal
          handleVisibleMajor={this.handleVisibleMajor}
          visible={uiState.majorVisible}
          majorData={this.state.majorData}
        ></IntelligentMajorModal>
        <IntelligentAllMajorModal
          handleVisibleAllMajor={this.handleVisibleAllMajor}
          handleInlineVisibleMajor={this.handleInlineVisibleMajor}
          visible={uiState.allMajorVisible}
          allMajorData={this.state.allMajorData}
        ></IntelligentAllMajorModal>
        {this.state.filterData != null ? (
          <IntelligentDataFilter
            handleConfirm={this.handleConfirm}
            handleVisibleFilter={this.handleVisibleFilter}
            visible={uiState.filterModuleVisible}
            filterData={this.state.filterData}
          ></IntelligentDataFilter>
        ) : (
          ""
        )}
        <IntelligentSearchBox
          handleVisibleFilter={this.handleVisibleFilter}
          handleRemoveName={this.handleRemoveName}
          schoolFilter={schoolFilter}
        ></IntelligentSearchBox>
        <IntelligentHomeHead
          open={this.handleOpen}
          handleSwitchYear={this.handleSwitchYear}
          schoolFilter={schoolFilter}
          handleVisibleAdvanceModal={this.handleVisibleAdvanceModal}
        ></IntelligentHomeHead>
        <IntelligentDataHead></IntelligentDataHead>
        <div style={{ height: 175 }}></div>
        {this.state.dataList.length === 0 && this.state.data !== null ? (
          <div>
            <ListErrorPrompt
              imgSrc={require("../../../images/school/notice.png")}
              toptext={
                schoolFilter.majorName !== "" && schoolFilter.schoolName !== ""
                  ? this.state.errorType +
                    "当前搜索的是" +
                    schoolFilter.schoolName +
                    "+" +
                    schoolFilter.majorName +
                    "<br />什么也没发现，请确保输入正确"
                  : this.state.errorType + "什么也没发现，请确保输入正确"
              }
              bottomtext="这里是所有裸考统招80个志愿的数据<br />提前批的数据见右上方"
            ></ListErrorPrompt>
          </div>
        ) : (
          ""
        )}
        {this.state.data != null ? (
          <div>
            {this.state.dataList.map((item, index) => {
              return (
                <IntelligentDataColumn
                  handleVisibleAllMajor={this.handleVisibleAllMajor}
                  handleVisibleMajor={this.handleVisibleMajor}
                  handleVisibleSchoolDetail={this.handleVisibleSchoolDetail}
                  key={index}
                  item={item}
                ></IntelligentDataColumn>
              );
            })}
            {schoolFilter.pageNum < this.state.data.data.pages ? (
              <Loading></Loading>
            ) : (
              <div className="schoolList_shim"></div>
            )}
          </div>
        ) : (
          ""
        )}
        <div className="schoolList_shim"></div>
        <ReturnTop visible={this.state.topVisible}></ReturnTop>
        <InfoModal
          visible={uiState.infoVisible}
          info={uiState.info}
          close={this.handleClose}
        ></InfoModal>
      </div>
    );
  }

  /**
   * 打开信息框
   */
  handleOpen = () => {
    const { dispatch } = this.props;
    dispatch(intelligentbigdataActions.setInfoVisible(true));
  };

  /**
   * 关闭信息框
   */
  handleClose = () => {
    const { dispatch } = this.props;
    dispatch(intelligentbigdataActions.setInfoVisible(false));
  };
  /**
   * 请求分享的配置
   */
  requestShareConfig = () => {
    const url = window.location.href;
    get("/api/share/config?url=" + url).then((res) => {
      if (res.status === "success") {
        let signature = res.data.signature;
        let timestamp = res.data.timestamp;
        let noncestr = res.data.nonceStr;
        let appid = res.data.appId;
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有public/v1的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: noncestr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名
          jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"], // 必填，需要使用的JS接口列表
        });

        window.wx.ready(function () {
          //分享给朋友
          window.wx.onMenuShareAppMessage({
            title: "浙考之家-每日高升-智能大数据", // 分享标题
            desc: "一站式升学、就业规划，找浙考之家", // 分享描述
            link: url, // 分享.链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标s
            type: "link", // 分享类型,music、video或link，不填默认为link
            dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
              // 用户确认分享后执行的回调函数
              //                 alert("OK");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              //                 alert("fail");
            },
          });
          //分享给朋友圈
          window.wx.onMenuShareTimeline({
            title: "浙考之家-每日高升-智能大数据", // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: "https://resource.zhekaozhijia.com/common/icon/logo.png", // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
            },
          });
        });
      }
    });
  };
  /**
   * 获取用户是否购买的标识
   */
  requestIsBuy = () => {
    get("/public/v1/user/isBuy").then((res) => {
      if (res.data === false) {
        jumpUrl("pay");
      }
    });
  };
  /**
   * 请求用户信息
   */
  requestUserInfo = () => {
    get("/public/v1/user/info").then((res) => {
      if (res.status === "success") {
        if (res.data.isBuy === false) {
          jumpUrl("pay");
        }
      } else {
        jumpUrl("");
      }
    });
  };
  /**
   * 顺序关闭modal框
   */
  orderCloseModal = (doWork) => {
    const { dispatch, uiState } = this.props;
    if (uiState.advanceMajorModalVisible === true) {
      dispatch(intelligentbigdataActions.setAdvanceMajorModalVisible(false));
    } else if (uiState.advanceModalVisible === true) {
      dispatch(intelligentbigdataActions.setAdvanceModalVisible(false));
    } else if (uiState.inlineMajorVisible === true) {
      dispatch(intelligentbigdataActions.setInlineMajorVisible(false));
    } else if (uiState.allMajorVisible === true) {
      dispatch(intelligentbigdataActions.setAllMajorVisible(false));
    } else if (uiState.majorVisible === true) {
      dispatch(intelligentbigdataActions.setMajorVisible(false));
    } else if (uiState.schoolDetailVisible === true) {
      dispatch(intelligentbigdataActions.setSchoolDetailVisible(false));
    } else if (uiState.filterModuleVisible === true) {
      dispatch(intelligentbigdataActions.setFilterModuleVisible(false));
    }
    doWork = false;
  };
  /**
   * 请求院校的过滤条件
   */
  requestSchoolFilter() {
    get("/public/v1/school/filter/3").then((res) => {
      this.setState({
        filterData: res.data,
      });
    });
  }
  /**
   * 请求院校专业列表
   */
  requestSchoolMajorList() {
    let params = {
      highScore:
        this.props.schoolFilter.highScore === ""
          ? null
          : this.props.schoolFilter.highScore,
      rowScore:
        this.props.schoolFilter.rowScore === ""
          ? null
          : this.props.schoolFilter.rowScore,
      maxRank:
        this.props.schoolFilter.maxRank === ""
          ? null
          : this.props.schoolFilter.maxRank,
      minRank:
        this.props.schoolFilter.minRank === ""
          ? null
          : this.props.schoolFilter.minRank,
      schoolName: this.props.schoolFilter.schoolName,
      majorName: this.props.schoolFilter.majorName,
      subjectIds: this.props.schoolFilter.subjectFilterId,
      limits: this.props.schoolFilter.limitFilterId,
      schoolLevelIds: this.props.schoolFilter.levelFilterId,
      schoolTagIds: this.props.schoolFilter.tagFilterId,
      schoolPropertyIds: this.props.schoolFilter.propertyFilterId,
      provinceIds: this.props.schoolFilter.provinceFilterId,
      year: this.props.schoolFilter.year,
      pageNum: this.props.schoolFilter.pageNum,
      pageSize: this.props.schoolFilter.pageSize,
    };

    //最高分最低分都不为空的情况
    if (params.highScore !== null && params.rowScore !== null) {
      //如果最低分的框输入高于最高分的框
      if (params.rowScore > params.highScore) {
        let tmpHScore = params.rowScore;
        params.rowScore = params.highScore;
        params.highScore = tmpHScore;
      }
    } else {
      //highScore填了数字 rowScore没有填数字的情况
      if (params.highScore !== null && params.rowScore === null) {
        params.rowScore = 0;
      }
      ////rowScore填了数字 highScore没有填数字的情况
      if (params.rowScore !== null && params.highScore === null) {
        params.highScore = 750;
      }
    }

    //最小位次和最大位次不为空的情况
    if (params.maxRank !== null && params.minRank !== null) {
      //如果最小位次的框输入值大于最大位次的框
      if (params.minRank > params.maxRank) {
        let tmpMRank = params.minRank;
        params.minRank = params.maxRank;
        params.maxRank = tmpMRank;
      }
    } else {
      //maxRank填了位次 minRank没有填位次的情况
      if (params.maxRank !== null && params.minRank === null) {
        params.minRank = 0;
      }
      ////minRank填了位次 maxRank填位次的情况
      if (params.minRank !== null && params.maxRank === null) {
        params.maxRank = 999999;
      }
    }
    if (params.schoolName === "" && params.majorName === "") {
      this.setState({
        errorType: "",
      });
    } else if (params.schoolName !== "" && params.majorName === "") {
      this.setState({
        errorType: "搜大学：",
      });
    } else if (params.schoolName === "" && params.majorName !== "") {
      this.setState({
        errorType: "搜专业：",
      });
    }

    post("/public/v1/intelligent/list", params).then((res) => {
      const newDataList = this.state.dataList.concat(res.data.list);
      this.setState({
        data: res,
        dataList: newDataList,
      });
      finished = true;
    });
  }
  /**
   * 添加scroll事件监听
   */
  handleAddScroll = () => {
    document.addEventListener("scroll", this.handleScroll);
  };
  /**
   * 控制过滤数据框显示和关闭
   */
  handleVisibleFilter = () => {
    const { dispatch } = this.props;
    dispatch(
      intelligentbigdataActions.setFilterModuleVisible(
        !this.props.uiState.filterModuleVisible
      )
    );
    history.pushState(null, null, document.URL);
  };
  /**
   * 控制院校提前批的专业框的显示和关闭
   */
  handleVisibleAdvanceMajorModal = (year) => {
    const { dispatch } = this.props;
    dispatch(
      intelligentbigdataActions.setAdvanceMajorModalVisible(
        !this.props.uiState.advanceMajorModalVisible
      )
    );
    if (year !== -1) {
      this.requestAdvanceSchoolMajor(year);
    }
  };
  /**
   * 控制院校提前批的主页面框显示和关闭
   */
  handleVisibleAdvanceModal = () => {
    const { dispatch } = this.props;
    dispatch(
      intelligentbigdataActions.setAdvanceModalVisible(
        !this.props.uiState.advanceModalVisible
      )
    );
    history.pushState(null, null, document.URL);
  };

  /**
   * 控制院校专业的显示框的显示和关闭
   */
  handleVisibleMajor = (majorHashId) => {
    const { dispatch } = this.props;
    dispatch(
      intelligentbigdataActions.setMajorVisible(
        !this.props.uiState.majorVisible
      )
    );
    if (majorHashId !== -1) {
      this.requestSchoolMajor(majorHashId);
    }
    history.pushState(null, null, document.URL);
  };

  /**
   * 控制内嵌的院校专业的显示框的显示和关闭
   */
  handleInlineVisibleMajor = (majorHashId) => {
    const { dispatch } = this.props;
    dispatch(
      intelligentbigdataActions.setInlineMajorVisible(
        !this.props.uiState.inlineMajorVisible
      )
    );
    if (majorHashId !== -1) {
      this.requestSchoolMajor(majorHashId);
    }
    history.pushState(null, null, document.URL);
  };
  /**
   * 控制学校详情页面显示框的显示和关闭
   */
  handleVisibleSchoolDetail = (aHashId) => {
    const { dispatch } = this.props;
    dispatch(
      intelligentbigdataActions.setSchoolDetailVisible(
        !this.props.uiState.schoolDetailVisible
      )
    );
    dispatch(
      intelligentbigdataActions.setAHashId(aHashId === -1 ? "8DFBj" : aHashId)
    );
    history.pushState(null, null, document.URL);
  };
  /**
   * 请求提前批的学校专业
   */
  requestAdvanceSchoolMajor = (year) => {
    get("/public/v1/intelligent/advance/majors/" + year).then((res) => {
      this.setState({
        advanceMajorData: res.data,
        advanceYear: year,
      });
    });
  };
  /**
   * 请求学校专业
   */
  requestSchoolMajor = (majorHashId) => {
    let params = {
      majorHashId: majorHashId,
      majorName: this.props.schoolFilter.majorName,
    };
    post("/public/v1/intelligent/major/detail", params).then((res) => {
      this.setState({
        majorData: res.data,
      });
    });
  };
  /**
   *  控制院校显示所有专业的显示框的显示和关闭
   */
  handleVisibleAllMajor = (iHashId) => {
    const { dispatch } = this.props;
    dispatch(
      intelligentbigdataActions.setAllMajorVisible(
        !this.props.uiState.allMajorVisible
      )
    );
    if (iHashId !== -1) {
      this.requestSchoolAllMajor(iHashId);
    }
    history.pushState(null, null, document.URL);
  };
  /**
   * 获取该学校所有的专业
   * @param {*} iHashId
   */
  requestSchoolAllMajor = (iHashId) => {
    get("/public/v1/intelligent/majors/" + iHashId).then((res) => {
      this.setState({
        allMajorData: res.data,
      });
    });
  };
  /**
   * 移除智能大数据主页的搜索条件
   */
  handleRemoveName = () => {
    const { dispatch } = this.props;
    finished = false;
    this.handleAddScroll();
    setTimeout(() => {
      dispatch(intelligentbigdataActions.setMajorName(""));
      dispatch(intelligentbigdataActions.setSchoolName(""));
      dispatch(intelligentbigdataActions.setPageNum(1));
      this.setState({
        dataList: [],
      });
      this.requestSchoolMajorList();
    });
  };

  /**
   * 切换智能大数据的省份
   */
  handleSwitchYear = (year) => {
    const { dispatch } = this.props;
    finished = false;
    this.handleAddScroll();
    setTimeout(() => {
      dispatch(intelligentbigdataActions.setYear(year));
      dispatch(intelligentbigdataActions.setPageNum(1));
      this.setState({
        dataList: [],
        data: null,
      });
      this.requestSchoolMajorList();
    });
  };
  /**
   * 确认操作
   */
  handleConfirm = () => {
    const { dispatch } = this.props;
    finished = false;
    this.handleAddScroll();
    setTimeout(() => {
      dispatch(intelligentbigdataActions.setPageNum(1));
      this.setState({
        dataList: [],
        data: null,
      });
      this.handleVisibleFilter();
      this.requestSchoolMajorList();
    });
  };
  // 处理屏幕滚动事件，实现加载更多的效果
  handleScroll = () => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const screenHeight = document.documentElement.clientHeight;
    const schoolListTop = this.myRef.current.offsetTop;
    const schoolListHeight = this.myRef.current.offsetHeight;
    if (
      finished &&
      scrollTop >= schoolListHeight + schoolListTop - screenHeight - 2
    ) {
      finished = false;
      setTimeout(() => {
        const { dispatch } = this.props;
        dispatch(
          intelligentbigdataActions.setPageNum(
            this.props.schoolFilter.pageNum + 1
          )
        );
        this.requestSchoolMajorList();
      });
    }
    if (scrollTop >= 1200) {
      this.setState({
        topVisible: true,
      });
    } else {
      this.setState({
        topVisible: false,
      });
    }
  };
}
const mapStateToProps = (state) => {
  return {
    schoolFilter: state.intelligentbigdata.schoolFilterData,
    uiState: state.intelligentbigdata.uiStateData,
    userInfo: state.user.userData.userInfo,
  };
};
export default connect(mapStateToProps)(IntelligentBigData);



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/index.js